// import React, { Component } from 'react';
import { Select } from 'antd';
import styled from 'styled-components';

// const $allocatedColor =  'green';
// const $unallocatedColor =  'red';
const $pendingColor =  '#ffa401';
const $declinedColor =  'maroon';
const $cancelledColor =  '#808080';
const $successColor =  '#3be6b1';
const $alertColor =  '#ff6767';
// const $changeTimeColor = 'magenta';


const colorMap = {
  'UNALLOCATED': $alertColor,
  'PENDING': $pendingColor,
  'ALLOCATED': $successColor,
  'AWAITING_PICKUP': $successColor,
  'BEING_COLLECTED': $successColor,
  'TRANSPORT_TO_GARAGE': $successColor,
  'AT_GARAGE': $pendingColor,
  'WORK_COMPLETE': $alertColor,
  'AWAITING_PAYMENT': $pendingColor,
  'LOCKED': $declinedColor,
  'PROCESSING': $pendingColor,
  'PAID': $pendingColor,
  'BEING_RETURNED': $successColor,
  'DELIVERED': $cancelledColor,
  'RETURNED': $cancelledColor,
  'CLOSED': $cancelledColor,
  'CANCELLED': $cancelledColor,
  'GARAGE_DECLINED': $declinedColor,
  'PAYMENT_FAILED': $declinedColor,
  'BOOKING_CHANGE': $pendingColor,
  'UNPAID': $alertColor,
  'DISPUTE': $alertColor,
}


export const StatusSelect = styled(Select)`
  ${Object.keys(colorMap).map((state) => `
      &.${state} {
        .ant-select-selection {
          background-color: ${colorMap[state]};
          color: white;
          font-weight: bold;
        }
        .ant-select-arrow .ant-select-arrow-icon {
          color: white;
        }
      }
    `
  )}
`
